<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        로그 상세 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">로그</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">시스템</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              로그 상세 정보
            </div>
            <div class="mb7">
              날짜 : {{model.created_at | datetime}}
            </div>
          </div>
          <hr>
          <!-- <pre>{{model}}</pre> -->
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover>
                사용자명
              </label>
            </div>
            <div class="col-xl-4 col-md-12">
              <label class="mt-2" for="ph_username" v-b-tooltip.hover>{{model.username}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_addr_all" v-b-tooltip.hover>
                주소
              </label>
            </div>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <label class="mt-1" for="ph_addr" v-b-tooltip.hover>{{model.addr_all}}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_addr_all" v-b-tooltip.hover>
                행위
              </label>
            </div>
            <div class="col-xl-4 col-md-12">
              <label class="mt-2" for="ph_addr_all" v-b-tooltip.hover>{{model.action}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_app_id" v-b-tooltip.hover>
                앱
              </label>
            </div>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <label class="mt-1" for="ph_app_id" v-b-tooltip.hover>
                <b-badge  variant="primary"> {{model.app_id}} </b-badge>
              </label>
            </div>
          </div>
          <b-button size="sm" class="float-right" variant="primary" @click="list">목록</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>